export enum TransactionFlow {
  Incoming = 'INCOMING',
  Outgoing = 'OUTGOING',
  None = ''
}
